/**
 * Shared severity helpers for drug/allergy interaction UI.
 */

export type SeverityMuiColor = "error" | "warning" | "info";

export function getSeverityColor(severity: string): SeverityMuiColor {
  if (isHighSeverity(severity)) return "error";
  if (isModerateSeverity(severity)) return "warning";
  return "info";
}

export function isHighSeverity(severity: string): boolean {
  return /^(high|severe)$/i.test(severity);
}

export function isModerateSeverity(severity: string): boolean {
  return /^moderate$/i.test(severity);
}

export function isMinorSeverity(severity: string): boolean {
  return /^(minor|low)$/i.test(severity);
}
